/**
 * CBH — Lipscore service review state
 * Keeps the testimonial panel useful when the third-party widget is delayed
 * or when no testimonial banner content is available.
 */
(() => {
  'use strict';

  if (window.CBH_LIPSCORE_SERVICE_REVIEWS_LOADED) return;
  window.CBH_LIPSCORE_SERVICE_REVIEWS_LOADED = true;

  const instances = new WeakMap();

  const widgetHasContent = (widget) => {
    if (!widget) return false;
    if (widget.children.length > 0) return true;
    return widget.textContent.trim().length > 24;
  };

  const initialise = (shell) => {
    if (!shell || instances.has(shell)) return;

    const widget = shell.querySelector('[data-cbh-lipscore-widget]');
    const fallback = shell.querySelector('[data-cbh-lipscore-fallback]');
    if (!widget) return;

    const update = () => {
      const ready = widgetHasContent(widget);
      shell.classList.toggle('is-ready', ready);
      shell.classList.toggle('is-waiting', !ready);
      if (fallback) fallback.setAttribute('aria-hidden', ready ? 'true' : 'false');
    };

    const observer = new MutationObserver(update);
    observer.observe(widget, { childList: true, subtree: true, characterData: true });

    instances.set(shell, observer);
    update();

    window.setTimeout(update, 1500);
    window.setTimeout(update, 5000);
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches?.('[data-cbh-lipscore-testimonial]')) initialise(scope);
    scope.querySelectorAll?.('[data-cbh-lipscore-testimonial]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-cbh-lipscore-testimonial]').forEach((shell) => {
      instances.get(shell)?.disconnect();
      instances.delete(shell);
    });
  });
})();
